import React from "react";
import { motion } from "framer-motion";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const CryptoCard = ({ name, symbol, price, change, sparkline_in_7d }) => {
  // Prepare chart data
  const chartData = {
    labels: Array.from({ length: 168 }, (_, i) => i), 
    datasets: [
      {
        label: `${name} Price Trend`,
        data: sparkline_in_7d.price, // Array of 168 price points
        borderColor: "rgba(59, 130, 246, 0.8)", // Blue line
        backgroundColor: "rgba(59, 130, 246, 0.2)", // Light blue fill
        tension: 0.4, // Smooth curve
        fill: true,
        pointRadius: 0, // No points for a cleaner sparkline
      },
    ],
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {// Hide legend
      title: { display: false }, 
    },
    scales: {
      x: { display: false }, 
      y: { display: false }, 
    },
  };

  return (
    <motion.div
      className="bg-gradient-to-br from-pink-800 to-violet-900 rounded-lg p-4 text-center shadow-lg lg:w-56 md:max-w-xs md:mx-auto  overflow-hidden"
      initial={{ x: "-100%", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.1 }}
    >
      <div className="h-24 mb-2">
        <Line data={chartData} options={chartOptions} />
      </div>
      <h3 className="text-xl font-semibold text-white">{name}</h3>
      <p className="text-gray-300">{symbol}</p>
      <p className="text-2xl font-bold text-white mt-2">${price.toLocaleString()}</p>
      <p className={`text-sm ${change >= 0 ? "text-green-400" : "text-red-400"}`}>
        {change.toFixed(2)}%
      </p>
    </motion.div>
  );
};

export default CryptoCard;